module.exports = __webpack_public_path__ + "img/system.66ba8a9c.png";